const apiUrl = environmentSettings.hostApiUrl + '/v1';

export default {
	APP_NAME: 'CTM Portal',
	LB_BASE_URL: environmentSettings.lightningBaseUrl,
	LB_URL: apiUrl + '/lightning',
	API_URL: apiUrl,
	API_URL_V2: environmentSettings.hostApiUrl + '/v2',
	TRACK_URL: 'http://localhost:3104',
	AUTH_DOMAIN: environmentSettings.authDomain,
	AUTH_CLIENT_ID: environmentSettings.authClientId,
	AUTH_CONNECTION: environmentSettings.authConnection,
	AUTH_CALLBACK_URL: location.protocol + '//' + location.host,
	AUTH_SCOPES: 'openid email profile all:ctmportal all:news all:lightning read:fareForecast activeTraveller:ctmportal appLink:ctmportal ticketcredits',
	AUTH_AUTHENTICATE_API_URL: apiUrl + '/authenticate',

	GOOGLE_MAPS_API_KEY: environmentSettings.googleMapsApiKey,

	SSO_DATA_FUNCTION_NAME: 'getSsoData',

	MIXPANEL_TOKEN: environmentSettings.mixpanelToken,

	SCOUT_SRC_URL: environmentSettings.scoutSrcUrl,

	UPLOAD_DOCUMENT_LIMIT: 10 * 1000 * 1000, // 10 MB

	APP_TILE_TYPES: {
		BOOKING: 'booking',
		INVOICE: 'invoice',
		PROFILE: 'profile',
		ETM: 'etm',
		DATA: 'data',
		APPROVAL: 'approval',
	},

	SSO_TYPE: {
		PKCE: 'PKCE',
	},

	ROLES: {
		TRAVELLER: 'traveller',
		TRAVEL_ARRANGER: 'travel arranger',
		CLIENT_MANAGER: 'client manager',
		TRAVEL_MANAGER: 'travel manager',
	},

	TRACKING_USER_MENU_OPENED: 'userMenuOpened',
	TRACKING_SIGNED_OUT: 'signedOut',
	TRACKING_TIMED_OUT: 'timedOut',
	TRACKING_SESSION_EXPIRED: 'sessionExpired',
	TRACKING_SESSION_EXTENDED: 'sessionExtended',
	TRACKING_APP_LAUNCHED: 'appLaunched',

	TRACKING_CREDITS_MENU_CLICKED: 'creditsMenuClicked',
	TRACKING_CREDITS_FILTER_APPLIED: 'creditsFilterApplied',
	TRACKING_CREDITS_FILTER_REMOVED: 'creditsFilterRemoved',
	TRACKING_CREDITS_SORT_APPLIED: 'creditsSortApplied',
	TRACKING_CREDITS_SORT_REMOVED: 'creditsSortRemoved',
	TRACKING_CREDITS_EXPORT_DOWNLOADED: 'creditsExportDownloaded',

	TRACKING_MAKE_BOOKING_CTA_CLICKED: 'makeBookingCTAClicked',
	TRACKING_UPDATE_POSTED: 'updatePosted',
	TRACKING_UPDATE_DELETED: 'updateDeleted',
	TRACKING_UPDATES_CATEGORY_CLICKED: 'updatesCategoryClicked',
	TRACKING_UPDATES_TAB_CLICKED: 'updatesTabClicked',
	TRACKING_DOCUMENT_DOWNLOADED: 'documentDownloaded',
	TRACKING_DOCUMENT_DELETED: 'documentDeleted',
	TRACKING_LINK_CLICKED: 'linkClicked',
	TRACKING_LINK_DELETED: 'linkDeleted',
	TRACKING_PREVIEW_LINK_CLICKED: 'previewLinkClicked',
	TRACKING_PREVIEW_LINK_DELETED: 'previewLinkDeleted',

	TRACKING_PERSON_SEARCHED: 'personSearched',
	TRACKING_PERSON_VIEWED: 'personViewed',
	TRACKING_PEOPLE_FILTER_APPLIED: 'peopleFilterApplied',
	TRACKING_PEOPLE_FILTER_REMOVED: 'peopleFilterRemoved',
	TRACKING_EDIT_PERSON: 'editPerson',
	TRACKING_VIEWED_PROFILE: 'viewedProfile',
	TRACKING_CLICK_CHANGE_PASSWORD: 'clickChangePassword',

	// TRACKING_FF_PLAN_PAGE_LOADED: 'planPageLoaded',
	TRACKING_FF_ROUTE_SEARCHED: 'routeSearched',
	TRACKING_FF_RECOMMENDED_ROUTE_LANCHED: 'recommendedRouteLaunched',

	TRACKING_FF_ORIGIN_CHANGED: 'originChanged',
	TRACKING_FF_DESTINATION_CHANGED: 'destinationChanged',
	TRACKING_FF_DATE_CHANGED: 'dateChanged',

	TRACKING_FF_DAY_CHANGED: 'dayChanged',
	TRACKING_FF_FILTER_APPLIED: 'filterApplied',
	TRACKING_FF_FILTER_REMOVED: 'filterRemoved',
	TRACKING_FF_BOOKING_DEEPLINKED: 'bookingDeeplinked',
};
